import React, { LegacyRef, useRef } from "react";
import Webcam from "react-webcam";
import { FaCamera, FaBan } from "react-icons/fa6";

import Button from "../../../atoms/Button/Button";

import "./ProfileWebcam.scss";
import "../../../tokens/alignment.scss";

const ProfileWebcam = ({ imageSource, setImageSource }: ProfileWebcamProps) => {
  const size = 310;
  const cam: LegacyRef<Webcam> = useRef(null);

  const snap = () => {
    const src = cam.current!.getScreenshot();
    setImageSource(src);
  };
  return (
    <div className="mp-templates-profileimagemodal--main-profile-webcam">
      <div className="main-image-container">
        {(imageSource as string) && <img src={imageSource as string} />}
        <Webcam
          ref={cam}
          style={{ display: imageSource ? "none" : "inherit" }}
          videoConstraints={{
            width: size,
            height: size,
            facingMode: "user",
          }}
        />
        <Overlay width={size} opacity={imageSource ? 0.9 : 0.7} />
      </div>
      <div className="main-content-controls">
        {imageSource ? (
          <Button
            label={<FaBan className="icon-only-button" />}
            onClick={() => setImageSource(null)}
            primary={false}
          />
        ) : (
          <Button
            label={<FaCamera className="icon-only-button" />}
            onClick={snap}
            primary={true}
          />
        )}
      </div>
    </div>
  );
};

export default ProfileWebcam;

interface ProfileWebcamProps {
  imageSource: string | null;
  setImageSource: (value: string | null) => void;
}

const Overlay = ({ width, opacity }: OverlayProps) => {
  return (
    <div style={{ position: "absolute", top: 0, width: width }}>
      <svg viewBox="0 0 100 100" width="100%" height="100%">
        <defs>
          <mask id="mask" x="0" y="0" width="100" height="100">
            <rect x="0" y="0" width="100" height="100" fill="#fff" />
            <circle cx="50" cy="50" r="48" />
          </mask>
        </defs>
        <rect
          x="0"
          y="0"
          width="100"
          height="100"
          mask="url(#mask)"
          fillOpacity={opacity}
          fill="#fff"
        />
        <circle
          cx="50"
          cy="50"
          r="48"
          // strokeDasharray="0 3"
          strokeLinecap="round"
          // strokeWidth="1"
          // stroke="#fff"
          fill="transparent"
        />
      </svg>
    </div>
  );
};

interface OverlayProps {
  width: number;
  opacity: number;
}
